import React, { PropTypes } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import ReactTimeout from "react-timeout";
import { FormattedMessage } from "react-intl";
import { toast } from "react-toastify";
import { canDownload } from "../../components/common/CanDownload";
import { downloaderEnums } from "../../utils/downloader/downloaderEnums";

import * as downloaderActions from "./downloaderActions";

class AttachmentsDownloader extends React.Component {
  /**
   * Since our attachments components (FollowUpAttachments and ClientAttachment) aren't react components,
   * it's not possible to handle downloads as the whole component is always rendering. This react
   * component will allow us to control the downloads using React's lifecycle methods.
   */
  constructor(props, context) {
    super(props, context);
  }


  componentDidMount(){
    if(this.props.queryParams && this.props.url && this.props.fileName){
      if(canDownload(this.props.fileName, this.props.currentDownloads)){
        this.props.downloaderActions.downloadFile(this.props.url, this.props.fileName, undefined, this.props.queryParams);
      }
      else{
        toast(
          <FormattedMessage id="downloader.duplicateDownload" values={{ file: this.props.fileName, br: <br/>}} />,
          {
            type: toast.TYPE.ERROR,
            autoClose: downloaderEnums.AUTO_CLOSE,
          }
        );
      }
    }
  }


  componentDidUpdate(prevProps){
    if(prevProps.currentDownloads != this.props.currentDownloads){
      /**
       * Checks if the file download is completed.
       */
      let fileExists = this.props.currentDownloads.some(file => file.identifier == this.props.fileName);

      if(!fileExists){
        /**
         * If it does we call the onDownloaded function which calls handleAttachmentDownloaded (clears S3 download from Redux store).
         */
        this.props.onDownloaded();
      }
    }
  }



  render() {

    return <i className="hidden" />;
  }
}

AttachmentsDownloader.propTypes = {
    fileName: PropTypes.string,
    url: PropTypes.string,
    queryParams: PropTypes.string,
    onDownloaded: PropTypes.func,
    currentDownloads: PropTypes.array,
    downloaderActions: PropTypes.object,
  };

function mapStateToProps(state) {
  const downloads = state.downloader || {};
  return {
    currentDownloads: downloads.currentDownloads || [],
    errorDownloads: downloads.errorDownloads || [],
    successDownloads: downloads.successDownloads || [],
  };
}

function mapDispatchToProps(dispatch) {
  return {
    downloaderActions: bindActionCreators(downloaderActions,dispatch)
  };
}

export default ReactTimeout(
  connect(mapStateToProps, mapDispatchToProps)(AttachmentsDownloader)
);



// WEBPACK FOOTER //
// ./src/utils/downloader/AttachmentsDownloader.js